import { render, staticRenderFns } from "./pcindex.vue?vue&type=template&id=60f6e650&scoped=true"
import script from "./pcindex.vue?vue&type=script&lang=js"
export * from "./pcindex.vue?vue&type=script&lang=js"
import style0 from "./pcindex.vue?vue&type=style&index=0&id=60f6e650&prod&scoped=true&lang=css"
import style1 from "./pcindex.vue?vue&type=style&index=1&id=60f6e650&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f6e650",
  null
  
)

export default component.exports